import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payloc',
  templateUrl: './payloc.component.html'
})
export class PaylocComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
